import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

const companyInfo = [
  { label: '会社名', value: '合同会社ＡＺ' },
  { label: '代表者', value: '藁科光' },
  { label: '設立', value: '令和5年' },
  { label: '所在地', value: '埼玉県三郷市高州３丁目１６４番地バンブーハイツ１０７' },
  { label: '電話番号', value: '090-6340-5373' },
  { label: 'メールアドレス', value: 'administrator@az-consulting-llc.com' },
  { label: '業務内容', value: 'コールセンターの企画、運営、管理 / 代行業務受託' },
  { label: '登記状況', value: '登記変更手続き中（2025年4月現在）' },
];

export default function AboutPage() {
  return (
    <>
      <Navbar />
      <main className="bg-white min-h-screen">
        {/* Page Hero */}
        <section className="relative bg-[#0f1628] geo-pattern pt-32 pb-20">
          <div className="absolute inset-0 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=abstract%20dark%20navy%20geometric%20pattern%20background%20with%20subtle%20golden%20grid%20lines%2C%20minimalist%20corporate%20texture%2C%20deep%20indigo%20tones%2C%20no%20people%2C%20pure%20abstract%20art%2C%20professional%20business%20atmosphere&width=1920&height=600&seq=about001&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top opacity-20"
            />
          </div>
          <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10">
            <span className="font-cormorant text-[#c9a84c] text-sm tracking-[0.4em] uppercase block mb-3">About Us</span>
            <h1 className="font-serif-jp text-white text-4xl md:text-5xl tracking-wider font-medium mb-4">会社概要</h1>
            <div className="flex items-center gap-3">
              <div className="w-12 h-px bg-[#c9a84c]"></div>
              <div className="w-1.5 h-1.5 bg-[#c9a84c] rotate-45"></div>
            </div>
          </div>
        </section>

        {/* Notice Banner */}
        <section className="bg-red-900/10 border-b border-red-800/20">
          <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-start gap-4">
            <span className="bg-red-700 text-white text-xs px-3 py-1 tracking-wider font-sans whitespace-nowrap mt-0.5">重要</span>
            <p className="text-[#0f1628] text-sm font-sans leading-relaxed">
              <strong className="font-medium">【登記変更手続き中のお知らせ】</strong>
              現在、合同会社ＡＺは登記変更手続きを進めております。手続き完了まで一部情報が旧登記内容と異なる場合がございますが、業務運営には支障ございません。ご不明な点はお気軽にお問い合わせください。
            </p>
          </div>
        </section>

        {/* Company Info Table */}
        <section className="py-20 md:py-28">
          <div className="max-w-5xl mx-auto px-6 md:px-10">
            <div className="mb-12">
              <span className="font-cormorant text-[#c9a84c] text-sm tracking-[0.4em] uppercase block mb-2">Company Profile</span>
              <h2 className="font-serif-jp text-[#0f1628] text-2xl md:text-3xl tracking-wider font-medium">会社情報</h2>
            </div>

            <div className="border-t border-[#0f1628]/10">
              {companyInfo.map((item) => (
                <div key={item.label} className="flex flex-col sm:flex-row border-b border-[#0f1628]/10 py-5 gap-2 sm:gap-0">
                  <dt className="sm:w-48 text-[#0f1628]/40 text-xs tracking-widest font-sans pt-0.5 flex-shrink-0">{item.label}</dt>
                  <dd className="text-[#0f1628] text-sm font-sans leading-relaxed flex-1">{item.value}</dd>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Mission */}
        <section className="bg-[#f8f5ef] py-20 md:py-28">
          <div className="max-w-7xl mx-auto px-6 md:px-10">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div>
                <span className="font-cormorant text-[#c9a84c] text-sm tracking-[0.4em] uppercase block mb-3">Our Mission</span>
                <h2 className="font-serif-jp text-[#0f1628] text-3xl md:text-4xl tracking-wider font-medium mb-8">
                  幅広い分野で、<br />
                  <span className="text-[#c9a84c]">業務委託を受託します。</span>
                </h2>
                <div className="flex items-center gap-3 mb-8">
                  <div className="w-12 h-px bg-[#c9a84c]"></div>
                  <div className="w-1.5 h-1.5 bg-[#c9a84c] rotate-45"></div>
                </div>
                <p className="text-[#0f1628]/60 text-sm leading-relaxed font-sans mb-6">
                  合同会社ＡＺは、コールセンターの企画・運営・管理を中心に、幅広い業務委託を受託する企業です。
                  お客様のビジネス課題に真摯に向き合い、確かな品質と誠実な対応でご支援いたします。
                </p>
                <p className="text-[#0f1628]/60 text-sm leading-relaxed font-sans">
                  設立以来、多様な業種・規模のお客様からご信頼をいただき、
                  アクティブかつ柔軟な対応力で、お客様の成長を共に創り続けています。
                </p>
              </div>
              <div className="relative">
                <img
                  src="https://readdy.ai/api/search-image?query=abstract%20geometric%20shapes%20with%20golden%20lines%20and%20dark%20navy%20background%2C%20corporate%20minimalist%20art%2C%20hexagonal%20patterns%20and%20diagonal%20lines%2C%20sophisticated%20business%20visual%2C%20no%20people%2C%20pure%20abstract%20design%2C%20gold%20and%20navy%20color%20scheme&width=600&height=500&seq=about002&orientation=landscape"
                  alt="合同会社ＡＺ ミッション"
                  className="w-full h-72 md:h-96 object-cover object-top"
                />
                <div className="absolute -bottom-4 -left-4 w-24 h-24 border border-[#c9a84c]/40"></div>
                <div className="absolute -top-4 -right-4 w-16 h-16 border border-[#c9a84c]/20"></div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}
